import {AdminAddSchoolForm} from './AdminAddSchoolForm';

export default AdminAddSchoolForm;
